import { Box, Grid, Typography } from '@mui/material';

const CmInfo = () => {
    const infos = [
        { year: '2024', description: 'Company Founded' },
        { year: '100 + ', description: 'Register လုပ်ထားသူ ဦးရေ' },
        { year: '100 + ', description: 'အလုပ်ခေါ်စာပေါင်း' },
    ];

    return (
        <Box
            sx={{
                width: '100%',
                px: 2,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                my: 10
            }}
        >
            <Grid container spacing={1} sx={{ mx: 'auto', maxWidth: 1200, userSelect: 'none' }}>
                {infos.map((info, index) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        key={index}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Box
                            sx={{
                                textAlign: 'center',
                                width: '100%',
                                maxWidth: 320,
                                py: 3,
                                px: 2,
                                m: 1,
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                backdropFilter: 'blur(5px)',
                                borderRadius: 2,
                                boxShadow: 3,
                                transition: 'all 0.3s ease-in-out',
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                    transform: 'scale(1.05)',
                                    transition: 'transform 0.3s ease-in-out',
                                },
                            }}
                        >
                            <Typography
                                sx={{
                                    color: '#fff',
                                    fontWeight: 'bold',
                                    fontFamily: 'Roboto, sans-serif',
                                    transition: 'all 0.3s ease-in-out',
                                }}
                                variant='h4'
                            >
                                {info.year}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: '20px',
                                    color: '#fff',
                                    mt: 2,
                                    fontFamily: 'Roboto, sans-serif',
                                    transition: 'all 0.3s ease-in-out',
                                }}
                            >
                                {info.description}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default CmInfo;
